module.exports = __webpack_public_path__ + "fa-regular-400.cf6008d396082c09c3dd.woff2";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-regular-400.woff2
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-regular-400.woff2
// module chunks = styles